import React, { useEffect } from 'react';

const FuturesBelowInfo = ({ mxLng, setMxLng, mxShrt, setMxShrt, tradePreliminary, quantity, priceStatic, pairDetails, tabMenu, trades, xMenu }) => {

    const setValues = (isLongPos, rootCal, longShort) => {
        const amount = isLongPos
        if (quantity > 0) {
            setMxLng(() => (+rootCal))
            setMxShrt(() => (+rootCal))

            if (longShort !== 'Long') {
                setMxLng(() => (+rootCal) + 0)
            }
            if (longShort === 'Short') {
                setMxLng(() => (+rootCal) + amount)
            }
            if (longShort !== 'Short') {
                setMxShrt(() => (+rootCal) + 0)
            }
            if (longShort === 'Long') {
                setMxShrt(() => (+rootCal) + amount)
            }
        }
    }
    useEffect(() => {
        if (tabMenu === 'Market') {
            const rootCal = (+quantity) / (+pairDetails.data?.lastPrice)
            let isLongPos = trades?.positions?.list?.length > 0 ? (trades?.positions?.list)?.find(data => data?.symbol === pairDetails?.data?.symbol) : ''
            const longShort = isLongPos?.side === 'Buy' ? 'Long' : 'Short'
            setValues(Number(isLongPos?.size), rootCal, longShort)

        }
        else if (tabMenu === 'Limit') {
            const rootCal = (+quantity) / (+priceStatic)
            let isLongPos = trades?.positions?.list?.length > 0 ? (trades?.positions?.list)?.find(data => data?.symbol === pairDetails?.data?.symbol) : ''
            const longShort = isLongPos?.side === 'Buy' ? 'Long' : 'Short'
            setValues(Number(isLongPos?.size), rootCal, longShort)

        }

    }, [pairDetails.data?.lastPrice, pairDetails.data?.symbol, quantity, tabMenu, trades?.positions, priceStatic])

    return (
        <div className='d-flex justify-content-between align-items-center overflow-hidden'>
            <div>
                <button onClick={() => tradePreliminary('buy', 'long')}>LONG</button>
                <div className='mt-2 pt-1 handleCostMaxText w-100'>
                    <p className='mb-1'>COST {(((+quantity) / (+xMenu)) + (0.06 / 100) || 0).toFixed(2)} USDT</p>
                    <p>MAX {(+mxLng || 0)?.toFixed(2)} USDT</p>
                </div>
            </div>
            <div>
                <button onClick={() => tradePreliminary('sell', 'short')}>SHORT</button>
                <div className='mt-2 pt-1 handleCostMaxText w-100 text-end'>
                    <p className='mb-1'>COST {(((+quantity) / (+xMenu)) + (0.06 / 100) || 0).toFixed(2)} USDT</p>
                    <p>MAX {(+mxShrt || 0)?.toFixed(2)} USDT</p>
                </div>
            </div>
        </div>
    );
};

export default FuturesBelowInfo;